export default __webpack_public_path__ + "static/apple-home-pod-d0dfc699d88aacb233aa7bfd93fc433e.jpg";